import {AuthConfigService, AuthHttpHeaderService, AuthInterceptor} from '@spartacus/core';
import {HttpErrorResponse, HttpInterceptor} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

@Injectable({providedIn: 'root'})
export class DcpAuthInterceptor extends AuthInterceptor implements HttpInterceptor {
  constructor(
    protected authHttpHeaderService: AuthHttpHeaderService,
    protected authConfigService: AuthConfigService,
    protected authService: DcpAuthService,
  ) {
    super(authHttpHeaderService, authConfigService);
  }

  isExpiredToken(resp: HttpErrorResponse): boolean {
    return (
      resp.error?.errors?.[0]?.type === 'InvalidTokenError' ||
      resp.error?.errors?.[0]?.type === 'InvalidBearerTokenError' ||
      resp.error?.errors?.[0]?.type === 'AccessDeniedError' ||
      resp.error?.errors?.[0]?.type === 'UnauthorizedError'
    );
  }
}
